import { render, staticRenderFns } from "./First.vue?vue&type=template&id=3b0deb2e&scoped=true&lang=pug"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"
import style0 from "./First.vue?vue&type=style&index=0&id=3b0deb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0deb2e",
  null
  
)

export default component.exports